import Component from "vue-class-component"
import Vue from "vue"

export const EventBus = new Vue()

@Component({})
export class WithEventBus extends Vue {
  eventBus = EventBus
}
